import { Switch } from "antd";
import { verificarPermissaoEmpresa } from "../../util/functions/verificarPermissaoEmpresa";

type SwitchComponentProps = {
  onChange?: (value: any) => void;
  checked?: any;
  disabled?: boolean;
};

export const SwitchComponent = ({ onChange, checked, disabled = false }: SwitchComponentProps) => {
  return (
    <Switch
      size="small"
      checked={checked}
      onChange={(value) => {
        onChange?.(value);
      }}
      disabled={disabled ? disabled : verificarPermissaoEmpresa() ? false : true}
    />
  );
};
